module.exports = __webpack_public_path__ + "images/header_left_1-ff86ac8977.png";